import { DecisionType, ExperimentDefinition, TestingVariant } from './AbTestingTypes';

const VariantA: TestingVariant = {
	name: 'Control',
	experimentName: 'Alpha',
	decisionPoints: [
		{
			id: 'ShowBraggingSection',
			type: DecisionType.Boolean,
			booleanValue: false,
		},
	],
};

const VariantB: TestingVariant = {
	name: 'Bragging',
	experimentName: 'Alpha',
	decisionPoints: [
		{
			id: 'ShowBraggingSection',
			type: DecisionType.Boolean,
			booleanValue: true,
		},
	],
};


const VariantC: TestingVariant = {
	name: 'DirectSanta',
	experimentName: 'Alpha',
	decisionPoints: [
		{
			id: 'InitialRoute',
			type: DecisionType.String,
			stringValue: '/story/all/chat/mikołaj/and-friends',
		},
	],
};

export const BraggingExperiment: ExperimentDefinition = {
	name: 'Alpha',
	variants: [
		{ variant: VariantA, weight: 0.25 },
		{ variant: VariantB, weight: 0.25 },
		{ variant: VariantC, weight: 0.5 },
	],
};

// const ControlVariant: TestingVariant = {
// 	name: 'LessButtons-Control',
// 	experimentName: 'LessButtons',
// 	decisionPoints: [
// 		{
// 			id: 'ShowExploreButton',
// 			type: DecisionType.Boolean,
// 			booleanValue: true,
// 		},
// 	],
// };
//
// const VariantB: TestingVariant = {
// 	name: 'LessButtons-B',
// 	experimentName: 'LessButtons',
// 	decisionPoints: [
// 		{
// 			id: 'ShowExploreButton',
// 			type: DecisionType.Boolean,
// 			booleanValue: false,
// 		},
// 	],
// };
//
// export const LessButtonsExperiment: ExperimentDefinition = {
// 	name: 'LessButtons',
// 	variants: [
// 		{ variant: ControlVariant, weight: 0.5 },
// 		{ variant: VariantB, weight: 0.5 },
// 	],
// };

export const ActiveExperiments: ExperimentDefinition[] = [BraggingExperiment];


